// extracted by mini-css-extract-plugin
module.exports = {"semibold":"Map_semibold__6kB67","map":"Map_map__0PemL","mapWrapper":"Map_mapWrapper__699gW","mapPath":"Map_mapPath__TuQAg"};